import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import { secondaryBlue } from 'utils/constants/ColorTheme'
import { Grid } from '@mui/material'

const VolumesSurveyTab = ({
    volumes,
}) => {
    return (
        <Grid container sx={{ marginTop: 1, marginBottom: '20px' }}>
            <Grid container size={12} sx={{ borderBottom: `solid 1px ${secondaryBlue}`, fontWeight: 'bold' }}>
                <Grid size={6}>
                    {i18n.type}
                </Grid>
                <Grid size={6}>
                    {i18n.requestedVolumes}
                </Grid>
            </Grid>
            {volumes.map((v) => (
                <Grid container size={12}>
                    <Grid size={6}>
                        {v.label}
                    </Grid>
                    <Grid size={3} sx={{ textAlign: 'end' }}>
                        {v.volume}
                    </Grid>
                </Grid>
            ))}
        </Grid>
    ) || null
}

VolumesSurveyTab.propTypes = {
    volumes: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        volume: PropTypes.string,
    })),
}

export default VolumesSurveyTab
